import type { Comprobante } from '../api';
import { formateaMoneda, letraDeTipo, numeroFormateado } from './dominio';

/**
 * El comprobante ya existe fiscalmente (KAN-145): `resultado: APROBADO`, con
 * CAE. No se borra ni se edita — se corrige con nota de crédito, que todavía
 * no existe en el front (fuera del alcance de esta tarjeta).
 *
 * Muestra la letra **como resultado**, nunca como algo que se pudo elegir: es
 * lo único que le dice al usuario qué salió, porque el formulario nunca tuvo
 * un selector para pedirla.
 */
export function ResultadoAprobado({
  comprobante,
  alEmitirOtro,
}: {
  comprobante: Comprobante;
  /** Arranca un comprobante nuevo: otra clave de idempotencia, formulario en blanco. */
  alEmitirOtro: () => void;
}) {
  return (
    <section aria-labelledby="resultado-aprobado-titulo">
      <h2 id="resultado-aprobado-titulo">Comprobante emitido</h2>
      <p>
        <strong>
          Factura {letraDeTipo(comprobante.tipo)} {numeroFormateado(comprobante.puntoVenta, comprobante.numero)}
        </strong>
      </p>
      <dl>
        <dt>CAE</dt>
        <dd>{comprobante.cae}</dd>
        <dt>Vencimiento del CAE</dt>
        <dd>{comprobante.caeVencimiento}</dd>
        <dt>Neto</dt>
        <dd>{formateaMoneda(comprobante.neto)}</dd>
        <dt>IVA</dt>
        <dd>{formateaMoneda(comprobante.iva)}</dd>
        <dt>Total</dt>
        <dd>
          <strong>{formateaMoneda(comprobante.total)}</strong>
        </dd>
      </dl>

      {comprobante.observaciones.length > 0 ? (
        <div role="status">
          {/* Una observación de ARCA no es un error: puede venir en una aprobación
              (la leyenda de la Factura A a monotributista salió de una). Se
              muestra igual, no se descarta por venir junto a un 201. */}
          <p>Observaciones de ARCA:</p>
          <ul>
            {comprobante.observaciones.map((o) => (
              <li key={o}>{o}</li>
            ))}
          </ul>
        </div>
      ) : null}

      <button type="button" onClick={alEmitirOtro}>
        Cargar otro comprobante
      </button>
    </section>
  );
}
